import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
// import * as dayjs from 'dayjs';
import { getCityList, 
  // getOtgList, 
getStreetList } from '../Axios/searchoff';
import Table from 'react-bootstrap/Table';
import { ToastContainer } from "react-toastify";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationLoe from './PaginationLoe';
import { defaultOptions, filterOption, selectOptions } from '../utils/search';
import { formatUTC } from '../utils/utils';
import dayjs from 'dayjs';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"


const SearchGrafikAvariy = ({getPodiys, type}) => {
  
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedStreet, setSelectedStreet] = useState(null);
  const [selectedOtg, 
    // setSelectedOtg
  ] = useState(null);
  const [selectedFrom, setSelectedFrom] = useState('');

  const [cityOptions, setCityOptions] = useState([]);
  // const [otgOptions, setOtgOptions] = useState([]);
  const [streetOptions, setStreetOptions] = useState([]);

  const [podiysList, setPodiysList] = useState([]);
  const [border, setBorder] = useState({otg: '#C4CBD2', city: '#C4CBD2', street: '#C4CBD2'});
  const [color, setColor] = useState({otg:'hsl(0, 0%, 50%)', city: 'hsl(0, 0%, 50%)', street: 'hsl(0, 0%, 50%)'});

  const formRef = useRef(null);
  const citySelect = useRef(null);
  const streetSelect = useRef(null);
  // const otgSelect = useRef(null);

  const tableOff = useRef(null);
  const dateFromRef = useRef(null);

  const [page, setPage] = useState(1);
  const [totalItems, setTotal] = useState(1);
  
  const [noOff, setNoOff] = useState('');

  const dateFilter = dayjs(selectedFrom).format("YYYY-MM-DD");    

  const maxDate = dayjs().subtract(3, 'day').format("YYYY-MM-DD");

  useEffect(()=>{
    // при першому завантаженні сторінки
    selectOptions(getCityList, setCityOptions); // витягуємо перелік всіх міст
    // selectOptions(getOtgList, setOtgOptions); // витягуємо перелік всіх отг

  },[]);


  useEffect(() => {
    // встановелння періода для пошуку за замовчуванням поточний день - 3 дні
      const fromSearchDate = dayjs().subtract(3, 'day').format('YYYY-MM-DD');
      setSelectedFrom(fromSearchDate);
  }, [])

  useEffect(()=>{
    if(selectedOtg !== null){
      selectOptions(getCityList, setCityOptions, selectedOtg.value);
    }
    if(selectedCity !== null){
      selectOptions(getStreetList, setStreetOptions, selectedCity.value);
    }
  },[selectedOtg, selectedCity])
  
  const handleChangePage = (currentPage)=> {
    formRef.current.scrollIntoView({behavior: 'smooth'})
    setPage(currentPage);
    getPodiys(dateFilter, selectedOtg?.value || '', selectedCity?.value || '', selectedStreet?.value || '', currentPage).then(response=>{
      const data = response['hydra:member'];
      setTotal(response['hydra:totalItems'])
      setPodiysList(data);
    })
  }

  function handleSubmit(e) {
    e.preventDefault();
    setPage(1);

    // відправка запиту в разі якщо дані заповнено місто + період або отг + період
    if ((selectedStreet !== null && selectedFrom !== '' && selectedCity !== null)) {
      getPodiys(dateFilter, selectedOtg?.value || '', selectedCity?.value || '', selectedStreet?.value || '', 1).then(response=>{
        const data = response['hydra:member'];
        setTotal(response['hydra:totalItems']);
        setPodiysList(data);
        if(data.length === 0) {
          toast.error('Вимкнень не знайдено 💡', {
            position: toast.POSITION.BOTTOM_LEFT
         });
         setNoOff('За обраним Вами періодом та населеним пунктом/вулицею відключень не зафіксовано.');
         clearData();
        }
      }).catch((err)=> {
        toast.error(`Помилка обробки даних ${err.message}`, {
            position: toast.POSITION.BOTTOM_LEFT
        });
        clearData();
      })
    }

    // відстеження незаповнених даних -- всі поля пусті

    if (selectedStreet === null && selectedCity === null && selectedFrom === '') {
      setBorder({street:'#e74c3c', city: '#e74c3c', dateTo: "#e74c3c", dateFrom: "#e74c3c"});
      setColor({street:'#e74c3c', city:'#e74c3c'});
      setTimeout(() => {
        setBorder({street:'#C4CBD2', city:'#C4CBD2', dateTo: "#C4CBD2", dateFrom: "#C4CBD2"});
        setColor({street:'hsl(0, 0%, 50%)', city:'hsl(0, 0%, 50%)'});
      }, 4000);
      setNoOff('');
      setPodiysList([]);
    }

    // відстеження незаповнених даних -- незаповнений період
    if ((selectedStreet !== null || selectedCity !== null) && (selectedFrom === '')) {
      setBorder({street:'#C4CBD2', city: '#C4CBD2', dateTo: "#e74c3c", dateFrom: "#e74c3c"});
      setTimeout(() => {
        setBorder({street:'#C4CBD2', city:'#C4CBD2', dateTo: "#C4CBD2", dateFrom: "#C4CBD2"});
      }, 4000);
      setNoOff('');
      setPodiysList([]);
    }

    // відстеження незаповнених даних -- незаповнений населений пункт/отг
    if ((selectedFrom !== '') && (selectedStreet === null && selectedCity === null)) {
      setBorder({street:'#e74c3c', city: '#e74c3c', dateTo: "#C4CBD2", dateFrom: "#C4CBD2"});
      setColor({street:'#e74c3c', city:'#e74c3c'});
      setTimeout(() => {
        setBorder({street:'#C4CBD2', city:'#C4CBD2', dateTo: "#C4CBD2", dateFrom: "#C4CBD2"});
        setColor({street:'hsl(0, 0%, 50%)', city:'hsl(0, 0%, 50%)'});
      }, 4000);
      setNoOff('');
      setPodiysList([]);
    }

    // відстеження незаповнених даних -- незаповнений вулиця
    if ((selectedFrom !== '') && (selectedStreet === null && selectedCity !== null)) {
      setBorder({street:'#e74c3c'});
      setColor({street:'#e74c3c'});
      setTimeout(() => {
        setBorder({street:'#C4CBD2'});
        setColor({street:'hsl(0, 0%, 50%)'});
      }, 4000);
      setNoOff('');
      setPodiysList([]);
    }
  }
  
  function clearData(){
    // otgSelect.current.clearValue();
    citySelect.current.clearValue(); 
    streetSelect.current.clearValue();

    // if(streetSelect !== null){
    //   selectOptions(getCityList, setCityOptions);
    // }
  }

  const dateOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };
  
  const timeOptions = {
    timeZone: 'UTC',
    hour: 'numeric', 
    minute: 'numeric',
  };

  return (
      <div className="search-off">
        <form action="submit" onSubmit={handleSubmit} ref={formRef} data-aos="fade-up">
          {/* <label htmlFor="otg">Об'єднана територіальна громада</label>
          <Select
            cacheOptions
            ref={otgSelect} 
            id={'otg'}
            placeholder={'Оберіть ОТГ'} 
            onChange={setSelectedOtg} 
            options={otgOptions}
            noOptionsMessage={() => 'Адреси не знайдено'} 
            loadingMessage={() => 'Завантаження...'}
            onSelectResetsInput = {false}
            onMenuOpen={clearData}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                border: `1px solid ${border.otg}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: 'white',
                paddingLeft: '10px',
              }),
              placeholder: (baseStyles) => ({
                ...baseStyles,
                color: color.otg
              })
            }}
            onFocus={()=>{setBorder({...border, otg: '#C4CBD2'}); setColor({...color, otg: 'hsl(0, 0%, 50%)'})}}
            /> */}
         <label htmlFor="city">Населений пункт*</label>
          <Select
            cacheOptions
            ref={citySelect} 
            id={'city'}
            placeholder={'Оберіть ваш населений пункт'} 
            onChange={setSelectedCity} 
            defaultOptions={defaultOptions}
            options={cityOptions}
            noOptionsMessage={() => 'Адреси не знайдено'} 
            loadingMessage={() => 'Завантаження...'}
            onSelectResetsInput = {false}
            filterOption={filterOption}
            onMenuOpen={() => {
              citySelect.current.clearValue(); 
              streetSelect.current.clearValue();
            }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: `1px solid ${border.city}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: state.isDisabled ? 'hsl(0, 0%, 95%)' : 'white',
                borderColor: state.isDisabled ? 'hsl(0, 0%, 90%)' : `1px solid ${border.city}`,
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                paddingLeft: '10px',
                opacity: state.isDisabled ? 0.7 : 1
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? 'hsl(0, 0%, 50%);' : color.city
              })
            }}
            onFocus={()=>{setBorder({...border, city: '#C4CBD2'}); setColor({...color, city: 'hsl(0, 0%, 50%)'})}}
            />
         <label htmlFor="street">Вулиця*</label>
         <Select 
            cacheOptions
            ref={streetSelect}
            id={'street'}
            placeholder={(selectedCity === null) ? 'Заповніть поле "Населений пункт"' : "Оберіть вашу вулицю"} 
            onChange={setSelectedStreet} 
            options={streetOptions}
            noOptionsMessage={() => 'Адреси не знайдено'} 
            loadingMessage={() => 'Завантаження...'}
            isDisabled={selectedCity === null}
            onMenuOpen={()=>streetSelect.current.clearValue()}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: `1px solid ${border.street}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: state.isDisabled ? 'hsl(0, 0%, 95%)' : 'white',
                borderColor: state.isDisabled ? 'hsl(0, 0%, 90%)' : `1px solid ${border.street}`,
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                paddingLeft: '10px',
                opacity: state.isDisabled ? 0.9 : 1
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? 'hsl(0, 0%, 50%);' : color.street
              })
            }}
            onFocus={()=>{setBorder({...border, street: '#C4CBD2'}); setColor({...color, street: 'hsl(0, 0%, 50%)'})}}
          />
          <div className="period-inner avariy">
            <div className="period-inner__field">
            <label htmlFor="from">Дата</label>
              <div className="picker-inner">
                <DatePicker
                    selected={selectedFrom ? new Date(selectedFrom) : null}
                    onChange={(date)=> {setSelectedFrom(date)}}
                    maxDate={maxDate}
                    locale="uk"
                    dateFormat="dd.MM.yyyy"
                    placeholderText="Оберіть дату"
                    className={"date-input"}
                    ref={dateFromRef}
                />
                  <i class="fa fa-calendar" onClick={() => dateFromRef.current.setOpen(true)}></i>
              </div>
            </div>
            {/* <div className="period-inner__field">
             <label htmlFor="to">Період по</label>
             <input type="date" 
              className={selectedTo !== '' ? 'date-input--has-value' : ''} 
              id='to' 
              value={selectedTo} 
              onChange={(e)=> {setSelectedTo(e.target.value)}}
              style={{borderColor: border.dateTo}} 
            />
            </div> */}
          </div>           
         <button className='power-btn'>Знайти</button>
         <ToastContainer/> 
       </form>
        {podiysList.length > 0 ?
        <>
          <div className="arrow-inner">	
            <div className="scroll-left" onClick={()=>{tableOff.current.scrollLeft -= 120;}}>&#8592;</div> 
            <div className="scroll-right" onClick={()=>{tableOff.current.scrollLeft += 120;}}>&#8594;</div>
          </div>
        <div className="search-off__table" ref={tableOff}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ОТГ</th>
              <th style={{minWidth: '170px'}}>Населений пункт</th>
              <th>Вулиця</th>
              <th style={{minWidth: '195px'}}>Будинок</th>
              <th style={{minWidth: '195px'}} >Тип відключення</th>
              <th style={{minWidth: '175px'}}> Час відключення</th>
              <th style={{minWidth: '165px'}}> Час включення</th>
            </tr>
          </thead>
          <tbody>
            {podiysList.map(podiy=>{
              return <tr key={podiy['@id']}>
                        <td>{podiy.otg.name}</td>
                        <td style={{textAlign: 'center'}}>{podiy.city.name}</td>
                        <td>{podiy.street.name}</td>
                        <td className='buildings-td' style={{maxWidth: '350px', wordWrap: 'break-word'}}>{podiy.buildingNames}</td>
                        <td style={{textAlign: 'center'}}>
                          {/* type передається з parent компоненту */}
                          {type === 1 ? 'Аварійне відключення' : 'Планове відключення'}
                        </td>
                        <td style={{textAlign: 'center'}}>{formatUTC(podiy.dateEvent, dateOptions, timeOptions)}</td>
                        <td style={{textAlign: 'center'}}>{formatUTC(podiy.datePlanIn, dateOptions, timeOptions)}</td>
                    </tr>
            })}
          </tbody>
          </Table>
          </div>
               <PaginationLoe
                changePage={handleChangePage}
                currentPage={page}
                total={totalItems}
                limit={30}
           /> 
        </> 
        : <p className="off-msg"><strong>{noOff}</strong></p>
      }
      {(podiysList.length > 0 || noOff.length > 0) && 
          <div className="date-synk grafics">
            — Інформацію сформовано станом на {dayjs(new Date()).format('DD.MM.YYYY HH:mm')}
          </div>
      }
      </div>
  )
}

export default SearchGrafikAvariy